<p class="finzy-p">Your passbook would be available once your loan gets funded.</p>
